module.exports = __webpack_public_path__ + "static/media/Rickey Parker 2_1591629933215.4eed8f14.jpg";